export default {
  data() {
    return {
      inputJson: '',
      outputJson: ''
    };
  },
  methods: {
    formatJson() {
      try {
        const json = JSON.parse(this.inputJson);
        this.outputJson = JSON.stringify(json, null, 2);
      } catch (error) {
        this.outputJson = '无效的 JSON 数据: ' + error.message;
      }
    },
    copyToClipboard() {
      if (this.outputJson) {
        navigator.clipboard.writeText(this.outputJson).then(() => {
          this.$message.success('复制成功！');
        }).catch(err => {
          this.$message.error('复制失败: ' + err);
        });
      }
    }
  }
};